// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import Link from 'next/link';
import * as S from './Banner.styled';
import { useState, useEffect } from 'react';
import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { getImageWithDelay } from '../../utils/DelayedImage';

const Banner = () => {
  const slowLoadEnabled = useBooleanFlagValue('imageSlowLoad', false);
  const [imageSrc, setImageSrc] = useState<string>('');

  useEffect(() => {
    let objectUrl = '';
    let cancelled = false;
    getImageWithDelay('/images/products/StarsenseExplorer.jpg', slowLoadEnabled)
      .then(blob => {
        if (cancelled) {
          return;
        }
        objectUrl = URL.createObjectURL(blob);
        setImageSrc(objectUrl);
      })
      .catch(error => {
        console.error('Failed to load banner image:', error);
      });
    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [slowLoadEnabled]);

  return (
    <S.Banner>
      <S.Inner>
        <S.TextContainer>
          <S.Eyebrow>Field-tested astronomy gear</S.Eyebrow>
          <S.Title>See further tonight.</S.Title>
          <S.Subtitle>
            Telescopes, binoculars, and imaging rigs for every kind of stargazer. Tracked from cart to doorstep.
          </S.Subtitle>
          <S.Actions>
            <S.GoShoppingButton as={Link} href="/?category=telescopes#shop">
              Shop telescopes
            </S.GoShoppingButton>
            <Link href="#shop">
              <S.GhostButton $type="secondary">Go Shopping</S.GhostButton>
            </Link>
          </S.Actions>
        </S.TextContainer>
        <S.Visual aria-hidden="true">
          <S.Porthole $src={imageSrc} />
          <S.FeaturedTag>
            <span>Featured</span> Starsense Explorer
          </S.FeaturedTag>
        </S.Visual>
      </S.Inner>
    </S.Banner>
  );
};

export default Banner;
